// Third-party imports
import { useQuery } from "@tanstack/react-query";

import { authKeys } from "./auth.queries";
import { handleApiError } from "@/lib/utils";
import { api } from "@/lib/axios";

export const useAuthUser = () => {
  return useQuery({
    queryKey: authKeys.me(),
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    queryFn: async () => {
      try {
        const response = await api.get("/api/auth/me");

        if (response.status !== 200) {
          throw new Error("Error fetching authenticated user");
        }

        return await response.data;
      } catch (error) {
        handleApiError(error);
        return null;
      }
    },
  });
};
